import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import appRouter from './routers/appRouter'
import { AuthProvider } from './contexts/AuthContext'
import ErrorBoundary from './shared/errorBoundary/ErrorBoundary'

function App() {
  return (
    <div className="App">
      {/* App-wide safety net: recovers from stale-deploy chunk errors (clear
          caches + reload once) and shows a graceful fallback for anything else. */}
      <ErrorBoundary>
        <AuthProvider>
          <RouterProvider router={appRouter()} />
        </AuthProvider>
      </ErrorBoundary>
      <ToastContainer containerId="default" />
    </div>
  )
}

export default App
